module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-16-6bc296712ecf35769a5fd62385c69b51.jpg";